import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX, L_FLOW_HEX } from '../../../constants';
export const BALANCER_CONFIG = {
    type: ERFElement.Balancer,
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow_1',
                    type: 'target',
                    name: 'Входной материальный поток №1',
                    position: Position.Left,
                    style: { top: 26, left: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_flow_2',
                    type: 'target',
                    name: 'Входной материальный поток №2',
                    position: Position.Left,
                    style: { top: 46, left: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow_1',
                    type: 'source',
                    name: 'Выходной материальный поток №1',
                    position: Position.Right,
                    style: { top: 26, right: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow_2',
                    type: 'source',
                    name: 'Выходной материальный поток №2',
                    position: Position.Right,
                    style: { top: 46, right: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 64, left: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 64, right: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFBalancerNode.config.js.map